// 七牛图片地址
export const qiniuUploadUrl = 'https://up.qiniup.com'; // 上传时的地址(华东区)
export const qiniuImageURLPrefix = 'https://img.senguo.cc/'; // 访问图片时的域名

// 隐私协议
export const privacyUrl = "https://i.senguo.cc/bbs/privacy/5eb92b2b36fcc540?hide=2&__target=_activity"
// 用户协议
export const userUrl = "https://i.senguo.cc/bbs/privacy/bc9b1db208600e72?hide=2&__target=_activity" 

// 小程序账号原始id
export const ORIGINAL_ID_OF_APPLET_ACCOUNT = {
    CG: 'gh_4d835acd822d', // 采购助手
    STAFF: 'gh_c2e2fcace81e', // 员工端
    OWNER: 'gh_65758f4124ad', // 货主端
    SENGUO: 'gh_da9c2fe064b3' // 森果云官方旗舰店小程序
}
